import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { longDate, shortDate, weekday, timeRange, usd, statusLabel, isOpen } from "@/lib/training";

const TONE = { ok: "text-emerald-300", warn: "text-amber-300", muted: "text-white/45" };

export default function OfferingOption({ o, selected, onSelect }) {
  const [expanded, setExpanded] = useState(false);
  const dates = o.session_dates || [];
  const st = statusLabel(o);
  const multi = dates.length > 1;
  return (
    <div data-testid={`offering-option-${o.id}`} className={`rounded-2xl border-2 transition-colors ${selected ? "border-white bg-white/[0.06]" : "border-white/10 hover:border-white/30"}`}>
      <button type="button" data-testid={`offering-select-${o.id}`} onClick={() => onSelect(o)} className="w-full text-left p-4 md:p-5 flex items-start gap-4">
        <span className={`mt-1 inline-flex items-center justify-center w-5 h-5 rounded-full border-2 shrink-0 ${selected ? "bg-white border-white text-[#0B0F19]" : "border-white/30"}`}>{selected && <Check size={12} strokeWidth={3.5} />}</span>
        <span className="flex-1 min-w-0">
          <span className="block text-base md:text-lg font-bold text-white">
            {multi ? `${shortDate(o.start_date)} – ${shortDate(o.end_date)}` : longDate(o.start_date)}
          </span>
          <span className="mt-1 block text-sm font-medium text-white/60">{[multi ? o.day : weekday(o.start_date), timeRange(o)].filter(Boolean).join(" · ")}</span>
          <span data-testid={`offering-status-${o.id}`} className={`mt-1.5 block text-xs font-bold uppercase tracking-wider ${TONE[st.tone]}`}>{st.text}</span>
        </span>
        <span className="text-right shrink-0">
          <span data-testid={`offering-price-${o.id}`} className="block text-xl font-extrabold tracking-tight text-white">{usd(o.full_enabled === false ? o.dropin_price : o.price)}</span>
          <span className="block text-[11px] font-semibold text-white/40">{o.full_enabled === false ? "per drop-in class" : multi ? `${dates.length} sessions` : "1 session"}</span>
        </span>
      </button>
      {multi && (
        <div className="px-4 md:px-5 pb-4 -mt-1">
          <button type="button" data-testid={`offering-dates-toggle-${o.id}`} onClick={() => setExpanded((x) => !x)} className="inline-flex items-center gap-1 text-xs font-bold text-white/60 hover:text-white">
            {expanded ? "Hide" : "View all"} {dates.length} dates <ChevronDown size={14} className={`transition-transform ${expanded ? "rotate-180" : ""}`} />
          </button>
          {expanded && (
            <ol data-testid={`offering-dates-${o.id}`} className="mt-2 space-y-1 text-sm font-medium text-white/75">
              {dates.map((d, i) => <li key={d}><span className="text-white/35 mr-2">{i + 1}.</span>{longDate(d)}</li>)}
            </ol>
          )}
        </div>
      )}
      {!isOpen(o) && selected && o.display_status === "full" && !o.waitlist_enabled && <p className="px-5 pb-4 text-xs font-semibold text-white/50">This session is full.</p>}
    </div>
  );
}
